// extracted by mini-css-extract-plugin
export default {"feeForm":"feesCategories_feeForm__WXQZm","group":"feesCategories_group__Yu0hV","eye":"feesCategories_eye__FmplM","error":"feesCategories_error__pvk89"};